import {
  DirectSalesCampaignDealLineRequest,
  DirectSalesPricingMode,
} from 'components/common/types/DirectSalesCampaign.types';
import { defaultDirectSalesLine } from 'store/dealManagement/defaults';

export const generateUniqueDealLineName = (
  existingNames: string[],
  idx: number,
  baseName: string = 'Deal line',
): string => {
  const newLineName = `${baseName} ${idx}`;

  if (!existingNames.includes(newLineName.toLowerCase())) return newLineName;

  return generateUniqueDealLineName(existingNames, idx + 1, baseName);
};

export const createNewDirectSalesLine = ({
  backupLineNames,
  defaultNonNetworkPricingMode = DirectSalesPricingMode.CPM,
}: {
  backupLineNames: string[];
  defaultNonNetworkPricingMode?: DirectSalesPricingMode.CPM | DirectSalesPricingMode.PANEL;
}): DirectSalesCampaignDealLineRequest => {
  const idx = backupLineNames.length + 1;
  const newLineName = generateUniqueDealLineName(backupLineNames, idx);

  return {
    ...defaultDirectSalesLine,
    name: newLineName,
    startDate: null,
    endDate: null,
    pricingMode: defaultNonNetworkPricingMode,
  };
};
